import React from "react";
import "../styles/OrderSummary.css";

const OrderSummary = ({ subtotal, shippingCost, taxes, totalReduced, totalInitPrice }) => {
  const formattedSubtotal = parseFloat(subtotal) || 0;
  const formattedShippingCost = parseFloat(shippingCost) || 0;
  const formattedTaxes = parseFloat(taxes) || 0;

  const total = (formattedSubtotal + formattedShippingCost).toFixed(2);
console.log(totalReduced.toFixed(2));
  return (
    <div className="order-summary">
      {totalReduced > 0 ? <div className="summary-item">
        <span className="summary-label"><strong>Réduction</strong></span>
        <span className="summary-value"><small style={{textDecoration: "line-through", color: "#333", fontWeight: 100}}>{totalInitPrice.toFixed(2)}&nbsp;€</small>&nbsp;&nbsp;<span style={{color: "#4FB897", fontSize: 20}}>-{totalReduced.toFixed(2)}&nbsp;€</span></span>
      </div> : null}
      <div className="summary-item">
        <span className="summary-label">Sous-total</span>
        <span className="summary-value">{total} €</span>
      </div>
      <div className="summary-item">
        <span className="summary-label">Livraison</span>
        <span className="summary-value">{formattedShippingCost === 0 ? "GRATUIT*" : `${formattedShippingCost.toFixed(2)} €`}</span>
      </div>
      <small style={{opacity: 0.5}}>*Livraison offerte en france !</small>
      <hr className="summary-divider" />
        {/* On affiche ici les options de paiement en x3 ou x4 si `payment` est true */}
        <div className="payment-options">
          <p 
            style={{
              marginInline: 15, 
              fontSize: 14,
              color: "#000"
            }}
          >
            <strong>3x sans frais</strong> via{" "}
            <img 
              src="/assets/logos/klarna.jpg" 
              style={{ 
                height: 25, 
                verticalAlign: 'middle', 
                borderRadius: 5, 
                padding: 3, 
                backgroundColor: "#FFB5C9", 
              }} 
              alt="klarna" 
            />
            &nbsp;| 3 x <strong>{(total / 3).toFixed(2)}&nbsp;€</strong><br/><br/>

            <strong>4x sans frais</strong> via{" "}
            <img 
              src="/assets/logos/paypal.png" 
              style={{ 
                height: 25, 
                verticalAlign: 'middle', 
                borderRadius: 5, 
                padding: 3, 
                backgroundColor: "#fff" 
              }} 
              alt="paypal"
            />
            &nbsp;| 4 x <strong>{(total / 4).toFixed(2)}&nbsp;€</strong>
          </p>
          <small style={{opacity: 0.5}}>Paiement en 3 ou 4 fois à sélectionner au moment du paiement</small>
        </div>
      <hr className="summary-divider" />

      <div className="summary-total">.
        <span className="summary-label-total">Total</span>
        <span className="summary-value-total">{total} € TTC</span>
      </div>
      <p className="summary-taxes">
        TVA et frais légaux inclus d’environ {formattedTaxes.toFixed(2)} €
      </p>
    </div>
  );
};

export default OrderSummary;
